import styled from '@emotion/styled';
import { Colors } from '../../../colors';

export const SendEmailModalStyled = {
  ModalContainerContent: styled.div`
    background-color: ${Colors.White};
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  `,
  ContentModal: styled.div`
    min-width: 300px;
    min-height: 200px;
    padding: 30px 30px 10px 30px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  `,
  TitleModal: styled.p`
    font-family: EncodeSans-Medium;
    font-size: 15px;
    color: ${Colors.Primary};
    text-align: center;
    margin-bottom: 10px;
  `,
  ButtonSend: styled.div`
    margin-top: 10px;
    height: 40px;
    background-color: ${Colors.Primary};
    border-radius: 5px;
    align-self: center;
    min-width: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  ContainerButtonSend: styled.div``,
  ContainerMessageEmail: styled.div``,
};
